import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  OnInit,
  Output,
  QueryList,
  SimpleChanges,
  ViewChildren
} from '@angular/core';
import { Breadcrumb, TreeNode } from '../../models/tree-models';

@Component({
  selector: 'app-fs-breadcrumb',
  templateUrl: './filesystem-breadcrumb.component.html',
  styleUrls: ['./filesystem-breadcrumb.component.scss']
})
export class FilesystemBreadcrumbComponent implements OnInit, OnChanges {
  @Input() navContainer: HTMLDivElement;
  @Input() search: HTMLDivElement;
  @Input() navigationContainer: HTMLDivElement;
  @Input() node: TreeNode;
  @Output() breadcrumbHandler: EventEmitter<string> = new EventEmitter<string>();
  @ViewChildren('overlayMenu') overlayMenu: QueryList<ElementRef>;

  pathArray: Breadcrumb[] = [];
  invisiblePathArray: Breadcrumb[] = [];
  previousWindowWidth: number;
  showPanel: boolean = false;

  constructor() {
    this.previousWindowWidth = window.innerWidth;
  }

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.node && !changes.node.firstChange) {
      this.setBreadcrumb();
      this.onResize(true);
    }
  }

  @HostListener('document:click', ['$event.target'])
  onClick(targetElement: HTMLElement): void {
    if (this.showPanel) {
      if (!targetElement) {
        return;
      }

      let clickedInside = false;

      this.overlayMenu.forEach((item) => {
        const overlayMenuElement = item.nativeElement;
        if (overlayMenuElement.contains(targetElement)) {
          clickedInside = true;
          return;
        }
      });

      this.showPanel = clickedInside ? true : false;
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(local?: boolean): void {
    const navContainerWidth = this.navContainer.offsetWidth;
    const searchWidth = this.search.offsetWidth;
    const navigationContainerWidth = this.navigationContainer.offsetWidth;
    const totalWidth = navContainerWidth + 16 + searchWidth;
    const isExpanding = window.innerWidth >= this.previousWindowWidth;
    const isContracting = window.innerWidth < this.previousWindowWidth;

    this.previousWindowWidth = window.innerWidth;

    const shouldAdjustBreadcrumb = () => {
      if (totalWidth > navigationContainerWidth && searchWidth === 120) this.adjustBreadcrumb(false);
      else if (totalWidth === navigationContainerWidth) this.adjustBreadcrumb(true);

      this.invisiblePathArray = this.pathArray.filter((item: Breadcrumb) => !item.visible);
    };

    if (typeof local === 'boolean' && local === true) shouldAdjustBreadcrumb();
    else {
      if (isContracting && totalWidth > navigationContainerWidth && searchWidth === 120) shouldAdjustBreadcrumb();
      else if (isExpanding && totalWidth === navigationContainerWidth) shouldAdjustBreadcrumb();
    }
  }

  breadcrumbClick(name: string, last: boolean) {
    if (last) {
      return;
    }
    this.breadcrumbHandler.emit(name);
  }

  private adjustBreadcrumb(expand: boolean): void {
    const filterCondition = expand ? (item: Breadcrumb) => !item.visible : (item: Breadcrumb) => item.visible;
    const array = this.pathArray.filter(filterCondition);

    if (array.length > 0) {
      const targetItem = expand ? array[array.length - 1] : array[0];
      targetItem.visible = expand;

      const index = this.pathArray.indexOf(targetItem);
      if (index !== -1) {
        this.pathArray[index] = targetItem;
      }
    }
  }

  setBreadcrumb() {
    if (!this.node) return;

    let path = this.node.path.replace(/:/g, '').replace(/\/$/, '');
    let tempArr = path.split('/');
    let indexSid3 = tempArr.indexOf('Home');

    this.pathArray =
      indexSid3 !== -1
        ? tempArr.map((stringa) => ({ name: stringa, visible: true }))
        : // .filter((oggetto) => !oggetto.name.includes('.'))
          [];
  }
}
